import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Vip from '../vip';
import Shop from '../shop';
import Login from '../login/login';
import LoginReturn from '../login/loginReturn';
import ErrorPage from '../Error';
import Home from '../home';
import Header from '../../components/header';
import Footer from '../../components/footer';
import WebAtmResult from '../shop/webAtmResult';
import PayInfoResult from '../shop/payInfo';


function App() {
    return (
        <div style={{ paddingTop: '50px' }}>
            <header>
                <Header />
            </header>
            <main>
                <Switch>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/login" component={Login} />
                    <Route exact path="/login/return" component={LoginReturn} />
                    <Route exact path="/error" component={ErrorPage} />
                    <Route exact path="/vip" component={Vip} />
                    <Route exact path="/shop/" component={Shop} />
                    <Route exact path="/shop/webatm/result" component={WebAtmResult} />
                    <Route exact path="/shop/creditcard/result" component={WebAtmResult} />
                    <Route exact path="/shop/atm/result" component={PayInfoResult} />
                    <Route exact path="/shop/mmk/result" component={PayInfoResult} />

                    <Route component={ErrorPage} />
                </Switch>
                <div className="cf"></div>
            </main>
            <br /><br />
            <Footer />
        </div>
    );
}

export default App


// WEBPACK FOOTER //
// ./src/containers/app/index.js